import { useState } from 'react'

export const STORAGE_KEYS = {
  THEME:             'florece-theme',
  LAST_MONTO:        'florece-last-monto',
  WEEKLY_DISMISSED:  'florece-weekly-dismissed',
  SURPLUS_DISMISSED: (year, month) => `florece-surplus-dismissed-${year}-${month}`,
}

export function getStorageJson(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback)) }
  catch { return fallback }
}

export function useLocalStorageState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = localStorage.getItem(key)
      return raw !== null ? JSON.parse(raw) : defaultValue
    } catch { return defaultValue }
  })
  function set(next) {
    try { localStorage.setItem(key, JSON.stringify(next)) } catch {}
    setValue(next)
  }
  return [value, set]
}
